// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"4828e6ea","598":"b0fdc935","652":"7952671a","703":"6a26bbcb","971":"f6d4a376"}[chunkId] + ".chunk.js";
};